// stays: the words of these screens in both languages. Each table is the
// one its component defined; moved here verbatim so a domain reads as one
// vocabulary and a translation is corrected in one place.
import { WOLOF, withWolof } from "./wolof";

// pages/Hotels.jsx
export const hotelsL = {
  en: {
    amenities: {
      wifi: "Wi-Fi", pool: "Pool", spa: "Spa", breakfast: "Breakfast",
      ac: "Air conditioning", parking: "Parking", gym: "Gym", beach: "Beach access",
    },
    modify: "Modify your search", hide: "Hide search",
    headline: "A place for every journey", heroAccent: "every journey", sub: "Find your next place to stay, for a night or a longer escape.",
    loading: "Finding hotels…",
    steps: ["Checking availability", "Loading property details",
            "Retrieving available rates", "Almost there…"],
    filterBy: "Filter by", clearAll: "Clear all",
    loadError: "We could not load stays.", retry: "Try again",
    stayType: "Type of stay",
    stayTypes: { hotel: "Hotels", apartment: "Apartments", house: "Houses & villas" },
    budget: "Your budget (per night)", anyPrice: "Any price", minPrice: "Minimum price", maxPrice: "Maximum price",
    popular: "Popular filters",
    popularOptions: { freeCancellation: "Free cancellation", breakfast: "Breakfast included", pool: "Swimming pool", wifi: "Free Wi-Fi", veryGood: "Very good: 4+" },
    reviewScore: "Guest rating",
    scores: { exceptional: "Exceptional", veryGood: "Very good", good: "Good", pleasant: "Pleasant" },
    rating: "Property rating", allProperties: "All properties",
    starsLabel: (n) => `${n} star${n > 1 ? "s" : ""}`,
    facilities: "Facilities", showAll: (n) => `Show all ${n}`, showLess: "Show less", remove: "Remove",
    foundIn: (city) => `${city}: Properties found`,
    count: (n) => `${n} propert${n !== 1 ? "ies" : "y"} · Prices for a 1-night stay`,
    sortBy: "Sort by:",
    stayTypesOne: { hotel: "Hotel", apartment: "Apartment", house: "House or villa" },
    toolbar: { label: "Sort, filter and map", sort: "Sort", filter: "Filter", map: "Map", sortHint: "Choose how the results are ordered.", quick: "Quick filters",
               list: "List", onMap: (n) => `${n} stay${n !== 1 ? "s" : ""} on the map`, perNight: " / night", view: "View" },
    noResults: "No results \u2014 try adjusting your filters.",
    sort: { recommended: "Default order", price: "Price (lowest first)",
            rating: "Guest rating (highest)", reviews: "Most reviewed" },
  },
  fr: {
    amenities: {
      wifi: "Wi-Fi", pool: "Piscine", spa: "Spa", breakfast: "Petit-déjeuner",
      ac: "Climatisation", parking: "Parking", gym: "Salle de sport", beach: "Accès plage",
    },
    modify: "Modifier votre recherche", hide: "Masquer la recherche",
    headline: "À chaque voyage, son adresse", heroAccent: "son adresse", sub: "Une nuit ou quelques jours : trouvez le séjour qui vous ressemble.",
    loading: "Recherche de logements…",
    steps: ["Vérification des disponibilités", "Chargement des informations des hébergements",
            "Recherche des tarifs disponibles", "Presque terminé…"],
    filterBy: "Filtrer par", clearAll: "Tout effacer",
    loadError: "Impossible de charger les hébergements.", retry: "Réessayer",
    stayType: "Type de logement",
    stayTypes: { hotel: "Hôtels", apartment: "Appartements", house: "Maisons et villas" },
    budget: "Votre budget (par nuit)", anyPrice: "Tous les prix", minPrice: "Prix minimum", maxPrice: "Prix maximum",
    popular: "Filtres populaires",
    popularOptions: { freeCancellation: "Annulation gratuite", breakfast: "Petit-déjeuner inclus", pool: "Piscine", wifi: "Wi-Fi gratuit", veryGood: "Très bien : 4+" },
    reviewScore: "Note des voyageurs",
    scores: { exceptional: "Exceptionnel", veryGood: "Très bien", good: "Bien", pleasant: "Agréable" },
    rating: "Étoiles", allProperties: "Tous les logements",
    starsLabel: (n) => `${n} étoile${n > 1 ? "s" : ""}`,
    facilities: "Équipements", showAll: (n) => `Afficher les ${n}`, showLess: "Afficher moins", remove: "Retirer",
    foundIn: (city) => `${city} : logements trouvés`,
    count: (n) => `${n} logement${n !== 1 ? "s" : ""} · Prix pour 1 nuit`,
    sortBy: "Trier par :",
    stayTypesOne: { hotel: "Hôtel", apartment: "Appartement", house: "Maison ou villa" },
    toolbar: { label: "Trier, filtrer, carte", sort: "Trier", filter: "Filtrer", map: "Carte", sortHint: "Choisissez l'ordre des résultats.", quick: "Filtres rapides",
               list: "Liste", onMap: (n) => `${n} hébergement${n > 1 ? "s" : ""} sur la carte`, perNight: " / nuit", view: "Voir" },
    noResults: "Aucun r\u00e9sultat \u2014 essayez d'ajuster vos filtres.",
    sort: { recommended: "Ordre par défaut", price: "Prix (croissant)",
            rating: "Note des voyageurs (décroissant)", reviews: "Les plus commentés" },
  },
  es: {
    amenities: {
      wifi: "Wi-Fi", pool: "Piscina", spa: "Spa", breakfast: "Desayuno",
      ac: "Aire acondicionado", parking: "Estacionamiento", gym: "Gimnasio", beach: "Acceso a la playa",
    },
    modify: "Modificar la búsqueda", hide: "Ocultar la búsqueda",
    headline: "Haga las maletas. Cambie de aire.", heroAccent: "Cambie de aire.", sub: "Una noche o unos días: encuentre dónde alojarse.",
    loading: "Buscando hoteles…",
    steps: ["Comprobando disponibilidad", "Cargando los detalles de los alojamientos",
            "Consultando las tarifas disponibles", "Ya casi está…"],
    filterBy: "Filtrar por", clearAll: "Borrar todo",
    loadError: "No pudimos cargar los alojamientos.", retry: "Reintentar",
    stayType: "Tipo de alojamiento",
    stayTypes: { hotel: "Hoteles", apartment: "Apartamentos", house: "Casas y villas" },
    budget: "Tu presupuesto (por noche)", anyPrice: "Cualquier precio", minPrice: "Precio mínimo", maxPrice: "Precio máximo",
    popular: "Filtros populares",
    popularOptions: { freeCancellation: "Cancelación gratuita", breakfast: "Desayuno incluido", pool: "Piscina", wifi: "Wi-Fi gratis", veryGood: "Muy bien: 4+" },
    reviewScore: "Puntuación de los huéspedes",
    scores: { exceptional: "Excepcional", veryGood: "Muy bien", good: "Bien", pleasant: "Agradable" },
    rating: "Categoría del alojamiento", allProperties: "Todos los alojamientos",
    starsLabel: (n) => `${n} estrella${n > 1 ? "s" : ""}`,
    facilities: "Servicios", showAll: (n) => `Mostrar los ${n}`, showLess: "Mostrar menos", remove: "Quitar",
    foundIn: (city) => `${city}: alojamientos encontrados`,
    count: (n) => `${n} alojamiento${n !== 1 ? "s" : ""} · Precios para 1 noche`,
    sortBy: "Ordenar por:",
    stayTypesOne: { hotel: "Hotel", apartment: "Apartamento", house: "Casa o villa" },
    toolbar: { label: "Ordenar, filtrar y mapa", sort: "Ordenar", filter: "Filtrar", map: "Mapa", sortHint: "Elige el orden de los resultados.", quick: "Filtros rápidos",
               list: "Lista", onMap: (n) => `${n} alojamiento${n !== 1 ? "s" : ""} en el mapa`, perNight: " / noche", view: "Ver" },
    noResults: "Sin resultados \u2014 prueba a ajustar los filtros.",
    sort: { recommended: "Orden predeterminado", price: "Precio (de menor a mayor)",
            rating: "Puntuación de los huéspedes (mayor primero)", reviews: "Más comentados" },
  },
  pt: {
    amenities: {
      wifi: "Wi-Fi", pool: "Piscina", spa: "Spa", breakfast: "Pequeno-almoço",
      ac: "Ar condicionado", parking: "Estacionamento", gym: "Ginásio", beach: "Acesso à praia",
    },
    modify: "Modificar a pesquisa", hide: "Ocultar a pesquisa",
    headline: "Faça as malas. Mude de ares.", heroAccent: "Mude de ares.", sub: "Uma noite ou uns dias: encontre o seu próximo alojamento.",
    loading: "A procurar hotéis…",
    steps: ["A verificar a disponibilidade", "A carregar os dados dos alojamentos",
            "A consultar as tarifas disponíveis", "Quase pronto…"],
    filterBy: "Filtrar por", clearAll: "Limpar tudo",
    loadError: "Não foi possível carregar as estadias.", retry: "Tentar novamente",
    stayType: "Tipo de alojamento",
    stayTypes: { hotel: "Hotéis", apartment: "Apartamentos", house: "Casas e vivendas" },
    budget: "O seu orçamento (por noite)", anyPrice: "Qualquer preço", minPrice: "Preço mínimo", maxPrice: "Preço máximo",
    popular: "Filtros populares",
    popularOptions: { freeCancellation: "Cancelamento gratuito", breakfast: "Pequeno-almoço incluído", pool: "Piscina", wifi: "Wi-Fi gratuito", veryGood: "Muito bom: 4+" },
    reviewScore: "Avaliação dos hóspedes",
    scores: { exceptional: "Excecional", veryGood: "Muito bom", good: "Bom", pleasant: "Agradável" },
    rating: "Classificação do alojamento", allProperties: "Todos os alojamentos",
    starsLabel: (n) => `${n} estrela${n > 1 ? "s" : ""}`,
    facilities: "Comodidades", showAll: (n) => `Mostrar todas (${n})`, showLess: "Mostrar menos", remove: "Remover",
    foundIn: (city) => `${city}: alojamentos encontrados`,
    count: (n) => `${n} alojamento${n !== 1 ? "s" : ""} · Preços para 1 noite`,
    sortBy: "Ordenar por:",
    stayTypesOne: { hotel: "Hotel", apartment: "Apartamento", house: "Casa ou moradia" },
    toolbar: { label: "Ordenar, filtrar e mapa", sort: "Ordenar", filter: "Filtrar", map: "Mapa", sortHint: "Escolha a ordem dos resultados.", quick: "Filtros rápidos",
               list: "Lista", onMap: (n) => `${n} alojamento${n !== 1 ? "s" : ""} no mapa`, perNight: " / noite", view: "Ver" },
    noResults: "Sem resultados \u2014 experimente ajustar os filtros.",
    sort: { recommended: "Ordem predefinida", price: "Preço (mais baixo primeiro)",
            rating: "Avaliação dos hóspedes (mais alta)", reviews: "Mais avaliados" },
  },
  ar: {
    amenities: {
      wifi: "واي فاي", pool: "مسبح", spa: "سبا", breakfast: "إفطار",
      ac: "تكييف هواء", parking: "موقف سيارات", gym: "صالة رياضية", beach: "وصول إلى الشاطئ",
    },
    modify: "تعديل البحث", hide: "إخفاء البحث",
    headline: "غيّر الأجواء واختر إقامتك", heroAccent: "غيّر الأجواء", sub: "ليلة واحدة أو عطلة أطول: اعثر على مكان إقامتك القادم.",
    loading: "جارٍ البحث عن الفنادق…",
    steps: ["التحقق من التوفر", "جارٍ تحميل تفاصيل أماكن الإقامة",
            "جارٍ جلب الأسعار المتاحة", "أوشكنا على الانتهاء…"],
    filterBy: "تصفية حسب", clearAll: "مسح الكل",
    loadError: "تعذر تحميل أماكن الإقامة.", retry: "حاول مرة أخرى",
    stayType: "نوع الإقامة",
    stayTypes: { hotel: "فنادق", apartment: "شقق", house: "منازل وفيلات" },
    budget: "ميزانيتك (لكل ليلة)", anyPrice: "أي سعر", minPrice: "الحد الأدنى للسعر", maxPrice: "الحد الأقصى للسعر",
    popular: "الفلاتر الشائعة",
    popularOptions: { freeCancellation: "إلغاء مجاني", breakfast: "الإفطار مشمول", pool: "مسبح", wifi: "واي فاي مجاني", veryGood: "جيد جدًا: 4+" },
    reviewScore: "تقييم النزلاء",
    scores: { exceptional: "استثنائي", veryGood: "جيد جدًا", good: "جيد", pleasant: "لطيف" },
    rating: "تصنيف مكان الإقامة", allProperties: "جميع أماكن الإقامة",
    starsLabel: (n) => `${n} ${n > 1 ? "نجوم" : "نجمة"}`,
    facilities: "المرافق", showAll: (n) => `عرض الكل (${n})`, showLess: "عرض أقل", remove: "إزالة",
    foundIn: (city) => `${city}: أماكن الإقامة المتاحة`,
    count: (n) => `${n} ${n !== 1 ? "أماكن إقامة" : "مكان إقامة"} · الأسعار لإقامة ليلة واحدة`,
    sortBy: "ترتيب حسب:",
    stayTypesOne: { hotel: "فندق", apartment: "شقة", house: "منزل أو فيلا" },
    toolbar: { label: "الترتيب والتصفية والخريطة", sort: "ترتيب", filter: "تصفية", map: "الخريطة", sortHint: "اختر ترتيب النتائج.", quick: "مرشحات سريعة",
               list: "القائمة", onMap: (n) => `${n} مكان إقامة على الخريطة`, perNight: " / ليلة", view: "عرض" },
    noResults: "لا توجد نتائج \u2014 جرّب تعديل الفلاتر.",
    sort: { recommended: "الترتيب الافتراضي", price: "السعر (الأقل أولًا)",
            rating: "تقييم النزلاء (الأعلى أولًا)", reviews: "الأكثر تقييمًا" },
  },
  zh: {
    amenities: {
      wifi: "Wi-Fi", pool: "泳池", spa: "水疗", breakfast: "早餐",
      ac: "空调", parking: "停车场", gym: "健身房", beach: "海滩直达",
    },
    modify: "修改搜索", hide: "收起搜索",
    headline: "换个地方，住进好时光", heroAccent: "住进好时光", sub: "住一晚，或多留几天，找到您心仪的落脚点。",
    loading: "正在查找酒店…",
    steps: ["正在查询空房", "正在加载住宿详情",
            "正在获取可用房价", "即将完成…"],
    filterBy: "筛选条件", clearAll: "全部清除",
    loadError: "无法加载住宿信息。", retry: "重试",
    stayType: "住宿类型",
    stayTypes: { hotel: "酒店", apartment: "公寓", house: "独栋房屋和别墅" },
    budget: "您的预算（每晚）", anyPrice: "不限价格", minPrice: "最低价格", maxPrice: "最高价格",
    popular: "热门筛选",
    popularOptions: { freeCancellation: "免费取消", breakfast: "含早餐", pool: "游泳池", wifi: "免费 Wi-Fi", veryGood: "很好：4 分以上" },
    reviewScore: "住客评分",
    scores: { exceptional: "卓越", veryGood: "很好", good: "好", pleasant: "不错" },
    rating: "住宿星级", allProperties: "全部住宿",
    starsLabel: (n) => `${n} 星`,
    facilities: "设施", showAll: (n) => `显示全部 ${n} 项`, showLess: "收起", remove: "移除",
    foundIn: (city) => `${city}：找到的住宿`,
    count: (n) => `${n} 家住宿 · 1 晚价格`,
    sortBy: "排序方式：",
    stayTypesOne: { hotel: "酒店", apartment: "公寓", house: "别墅或住宅" },
    toolbar: { label: "排序、筛选和地图", sort: "排序", filter: "筛选", map: "地图", sortHint: "选择结果的排列方式。", quick: "快速筛选",
               list: "列表", onMap: (n) => `地图上有 ${n} 处住宿`, perNight: " / 晚", view: "查看" },
    noResults: "没有结果 \u2014 请尝试调整筛选条件。",
    sort: { recommended: "默认排序", price: "价格（从低到高）",
            rating: "住客评分（从高到低）", reviews: "点评最多" },
  },
};

// pages/HotelDetail.jsx
export const hotelDetailL = {
  en: {
    amenities: {
      wifi: "Wi-Fi", pool: "Pool", spa: "Spa", breakfast: "Breakfast",
      ac: "Air conditioning", parking: "Parking", gym: "Gym",
      beach: "Beach access", bar: "Bar", restaurant: "Restaurant",
    },
    loading: "Loading…", error: "Error",
    showArea: "Show area", reserve: "Reserve",
    spaces: { title: "The rooms", bedroom: (i) => `Bedroom ${i}`, livingRoom: "Living room", beds: (n) => `${n} bed${n > 1 ? "s" : ""}`, bathroom: "Private bathroom" },
    tabs: { overview: "Overview", rooms: "Rooms", facilities: "Facilities",
            reviews: "Reviews", policies: "Policies" },
    excellent: "Excellent", veryGood: "Very good", good: "Good",
    reviews: (n) => `${n} reviews`,
    checkInLabel: "Check-in", checkInVal: "Check the arrival time in the selected offer.",
    checkOutLabel: "Check-out", checkOutVal: "Check the departure time in the selected offer.",
    cancelLabel: "Cancellation", cancelVal: "Cancellation rules depend on the selected rate. Review them before booking.",
    childrenLabel: "Children & extra beds", childrenVal: "Check the occupancy rules and any charges for children or extra beds.",
    payLabel: "Payment methods", payVal: "Available methods are shown at payment.",
    from: "From", bestPrice: "Selected rate", guests: "Guests",
    stars: (n) => `${n}-star property`, guestReviews: (n) => `${n} guest reviews`, perNight: "per night",
    guestsOpt: (n) => `${n} guest${n > 1 ? "s" : ""}`, roomsOpt: (n) => `${n} room${n > 1 ? "s" : ""}`,
    nights: (n) => `${n} night${n > 1 ? "s" : ""}`,
    total: "Total", taxes: "Includes taxes and fees",
    reserveNow: "Reserve", notCharged: "You won't be charged yet",
    roomList: { count: (n) => `${n} room type${n > 1 ? "s" : ""}`, swipe: "Swipe to see the other rooms.", guests: (n) => `${n} guest${n > 1 ? "s" : ""}`,
                left: (n) => `${n} left`, full: "Fully booked", choose: "Choose this room", chosen: "Chosen ✓" },
  },
  fr: {
    amenities: {
      wifi: "Wi-Fi", pool: "Piscine", spa: "Spa", breakfast: "Petit-déjeuner",
      ac: "Climatisation", parking: "Parking", gym: "Salle de sport",
      beach: "Accès plage", bar: "Bar", restaurant: "Restaurant",
    },
    loading: "Chargement…", error: "Erreur",
    showArea: "Voir la zone", reserve: "Réserver",
    spaces: { title: "Les pièces", bedroom: (i) => `Chambre ${i}`, livingRoom: "Salon", beds: (n) => `${n} lit${n > 1 ? "s" : ""}`, bathroom: "Salle de bain privée" },
    tabs: { overview: "Présentation", rooms: "Chambres", facilities: "Équipements",
            reviews: "Avis", policies: "Conditions" },
    excellent: "Excellent", veryGood: "Très bien", good: "Bien",
    reviews: (n) => `${n} avis`,
    checkInLabel: "Arrivée", checkInVal: "Vérifiez l’horaire d’arrivée dans l’offre sélectionnée.",
    checkOutLabel: "Départ", checkOutVal: "Vérifiez l’horaire de départ dans l’offre sélectionnée.",
    cancelLabel: "Annulation", cancelVal: "Les conditions d’annulation dépendent du tarif choisi. Consultez-les avant de réserver.",
    childrenLabel: "Enfants et lits d'appoint", childrenVal: "Vérifiez la capacité du logement et les éventuels frais pour les enfants ou les lits d’appoint.",
    payLabel: "Moyens de paiement", payVal: "Les moyens disponibles sont indiqués à l’étape du paiement.",
    from: "À partir de", bestPrice: "Tarif sélectionné", guests: "Voyageurs",
    stars: (n) => `Établissement ${n} étoiles`, guestReviews: (n) => `${n} avis voyageurs`, perNight: "par nuit",
    guestsOpt: (n) => `${n} voyageur${n > 1 ? "s" : ""}`, roomsOpt: (n) => `${n} chambre${n > 1 ? "s" : ""}`,
    nights: (n) => `${n} nuit${n > 1 ? "s" : ""}`,
    total: "Total", taxes: "Taxes et frais compris",
    reserveNow: "R\u00e9server", notCharged: "Vous ne serez pas encore d\u00e9bit\u00e9",
    roomList: { count: (n) => `${n} type${n > 1 ? "s" : ""} de chambre`, swipe: "Faites glisser pour voir les autres chambres.", guests: (n) => `${n} voyageur${n > 1 ? "s" : ""}`,
                left: (n) => `${n} disponible${n > 1 ? "s" : ""}`, full: "Complet", choose: "Choisir cette chambre", chosen: "Choisie ✓" },
  },
  es: {
    amenities: {
      wifi: "Wi-Fi", pool: "Piscina", spa: "Spa", breakfast: "Desayuno",
      ac: "Aire acondicionado", parking: "Estacionamiento", gym: "Gimnasio",
      beach: "Acceso a la playa", bar: "Bar", restaurant: "Restaurante",
    },
    loading: "Cargando…", error: "Error",
    showArea: "Ver la zona", reserve: "Reservar",
    spaces: { title: "Las habitaciones", bedroom: (i) => `Dormitorio ${i}`, livingRoom: "Sala de estar", beds: (n) => `${n} cama${n > 1 ? "s" : ""}`, bathroom: "Baño privado" },
    tabs: { overview: "Descripción", rooms: "Habitaciones", facilities: "Servicios",
            reviews: "Opiniones", policies: "Condiciones" },
    excellent: "Excelente", veryGood: "Muy bien", good: "Bien",
    reviews: (n) => `${n} opiniones`,
    checkInLabel: "Entrada", checkInVal: "Consulte la hora de entrada de la oferta seleccionada.",
    checkOutLabel: "Salida", checkOutVal: "Consulte la hora de salida de la oferta seleccionada.",
    cancelLabel: "Cancelación", cancelVal: "La cancelación depende de la tarifa elegida. Consulte las condiciones antes de reservar.",
    childrenLabel: "Niños y camas supletorias", childrenVal: "Consulte la ocupación permitida y los posibles cargos por niños o camas adicionales.",
    payLabel: "Métodos de pago", payVal: "Los métodos disponibles se indican al pagar.",
    from: "Desde", bestPrice: "Tarifa seleccionada", guests: "Huéspedes",
    stars: (n) => `Alojamiento de ${n} estrellas`, guestReviews: (n) => `${n} opiniones de huéspedes`, perNight: "por noche",
    guestsOpt: (n) => `${n} huésped${n > 1 ? "es" : ""}`, roomsOpt: (n) => `${n} habitaci${n > 1 ? "ones" : "ón"}`,
    nights: (n) => `${n} noche${n > 1 ? "s" : ""}`,
    total: "Total", taxes: "Impuestos y tasas incluidos",
    reserveNow: "Reservar", notCharged: "Todavía no se te cobrará nada",
    roomList: { count: (n) => `${n} tipo${n > 1 ? "s" : ""} de habitación`, swipe: "Desliza para ver las demás habitaciones.", guests: (n) => `${n} huésped${n > 1 ? "es" : ""}`,
                left: (n) => `${n} disponible${n > 1 ? "s" : ""}`, full: "Completo", choose: "Elegir esta habitación", chosen: "Elegida ✓" },
  },
  pt: {
    amenities: {
      wifi: "Wi-Fi", pool: "Piscina", spa: "Spa", breakfast: "Pequeno-almoço",
      ac: "Ar condicionado", parking: "Estacionamento", gym: "Ginásio",
      beach: "Acesso à praia", bar: "Bar", restaurant: "Restaurante",
    },
    loading: "A carregar…", error: "Erro",
    showArea: "Ver a zona", reserve: "Reservar",
    spaces: { title: "Os quartos", bedroom: (i) => `Quarto ${i}`, livingRoom: "Sala de estar", beds: (n) => `${n} cama${n > 1 ? "s" : ""}`, bathroom: "Casa de banho privativa" },
    tabs: { overview: "Descrição", rooms: "Quartos", facilities: "Comodidades",
            reviews: "Avaliações", policies: "Condições" },
    excellent: "Excelente", veryGood: "Muito bom", good: "Bom",
    reviews: (n) => `${n} avaliações`,
    checkInLabel: "Check-in", checkInVal: "Consulte a hora de entrada na oferta selecionada.",
    checkOutLabel: "Check-out", checkOutVal: "Consulte a hora de saída na oferta selecionada.",
    cancelLabel: "Cancelamento", cancelVal: "O cancelamento depende da tarifa escolhida. Consulte as condições antes de reservar.",
    childrenLabel: "Crianças e camas extra", childrenVal: "Consulte a ocupação permitida e os eventuais custos para crianças ou camas extra.",
    payLabel: "Métodos de pagamento", payVal: "Os meios disponíveis são apresentados no pagamento.",
    from: "A partir de", bestPrice: "Tarifa selecionada", guests: "Hóspedes",
    stars: (n) => `Alojamento de ${n} estrelas`, guestReviews: (n) => `${n} avaliações de hóspedes`, perNight: "por noite",
    guestsOpt: (n) => `${n} hóspede${n > 1 ? "s" : ""}`, roomsOpt: (n) => `${n} quarto${n > 1 ? "s" : ""}`,
    nights: (n) => `${n} noite${n > 1 ? "s" : ""}`,
    total: "Total", taxes: "Inclui impostos e taxas",
    reserveNow: "Reservar", notCharged: "Ainda não será cobrado nada",
    roomList: { count: (n) => `${n} tipo${n > 1 ? "s" : ""} de quarto`, swipe: "Deslize para ver os outros quartos.", guests: (n) => `${n} hóspede${n > 1 ? "s" : ""}`,
                left: (n) => `${n} disponíve${n > 1 ? "is" : "l"}`, full: "Esgotado", choose: "Escolher este quarto", chosen: "Escolhido ✓" },
  },
  ar: {
    amenities: {
      wifi: "واي فاي", pool: "مسبح", spa: "سبا", breakfast: "إفطار",
      ac: "تكييف هواء", parking: "موقف سيارات", gym: "صالة رياضية",
      beach: "وصول إلى الشاطئ", bar: "بار", restaurant: "مطعم",
    },
    loading: "جارٍ التحميل…", error: "خطأ",
    showArea: "عرض المنطقة", reserve: "احجز",
    spaces: { title: "الغرف", bedroom: (i) => `غرفة نوم ${i}`, livingRoom: "غرفة معيشة", beds: (n) => `${n} ${n > 1 ? "أسرّة" : "سرير"}`, bathroom: "حمام خاص" },
    tabs: { overview: "نظرة عامة", rooms: "الغرف", facilities: "المرافق",
            reviews: "التقييمات", policies: "الشروط" },
    excellent: "ممتاز", veryGood: "جيد جدًا", good: "جيد",
    reviews: (n) => `${n} تقييمًا`,
    checkInLabel: "تسجيل الوصول", checkInVal: "تحقق من وقت الوصول في العرض المحدد.",
    checkOutLabel: "تسجيل المغادرة", checkOutVal: "تحقق من وقت المغادرة في العرض المحدد.",
    cancelLabel: "الإلغاء", cancelVal: "تختلف شروط الإلغاء حسب السعر المحدد. راجعها قبل الحجز.",
    childrenLabel: "الأطفال والأسرّة الإضافية", childrenVal: "تحقق من سعة الإقامة وأي رسوم للأطفال أو الأسرّة الإضافية.",
    payLabel: "طرق الدفع", payVal: "تظهر وسائل الدفع المتاحة في خطوة الدفع.",
    from: "ابتداءً من", bestPrice: "السعر المحدد", guests: "النزلاء",
    stars: (n) => `مكان إقامة ${n} نجوم`, guestReviews: (n) => `${n} تقييمًا من النزلاء`, perNight: "لكل ليلة",
    guestsOpt: (n) => `${n} ${n > 1 ? "نزلاء" : "نزيل"}`, roomsOpt: (n) => `${n} ${n > 1 ? "غرف" : "غرفة"}`,
    nights: (n) => `${n} ${n > 1 ? "ليالٍ" : "ليلة"}`,
    total: "الإجمالي", taxes: "شامل الضرائب والرسوم",
    reserveNow: "احجز", notCharged: "لن يتم خصم أي مبلغ الآن",
    roomList: { count: (n) => `${n} من أنواع الغرف`, swipe: "اسحب لرؤية الغرف الأخرى.", guests: (n) => `${n} نزلاء`,
                left: (n) => `${n} متاحة`, full: "محجوزة بالكامل", choose: "اختر هذه الغرفة", chosen: "تم الاختيار ✓" },
  },
  zh: {
    amenities: {
      wifi: "Wi-Fi", pool: "泳池", spa: "水疗", breakfast: "早餐",
      ac: "空调", parking: "停车场", gym: "健身房",
      beach: "海滩直达", bar: "酒吧", restaurant: "餐厅",
    },
    loading: "加载中…", error: "出错了",
    showArea: "查看周边", reserve: "预订",
    spaces: { title: "房间", bedroom: (i) => `卧室 ${i}`, livingRoom: "客厅", beds: (n) => `${n} 张床`, bathroom: "独立卫浴" },
    tabs: { overview: "概览", rooms: "客房", facilities: "设施",
            reviews: "点评", policies: "政策" },
    excellent: "极佳", veryGood: "很好", good: "好",
    reviews: (n) => `${n} 条点评`,
    checkInLabel: "入住", checkInVal: "请查看所选房型的入住时间。",
    checkOutLabel: "退房", checkOutVal: "请查看所选房型的退房时间。",
    cancelLabel: "取消政策", cancelVal: "取消规则取决于所选房价，请在预订前查看。",
    childrenLabel: "儿童与加床", childrenVal: "请查看入住人数限制及儿童或加床费用。",
    payLabel: "支付方式", payVal: "可用支付方式将在付款时显示。",
    from: "起价", bestPrice: "所选房价", guests: "住客",
    stars: (n) => `${n} 星级住宿`, guestReviews: (n) => `${n} 条住客点评`, perNight: "每晚",
    guestsOpt: (n) => `${n} 位住客`, roomsOpt: (n) => `${n} 间客房`,
    nights: (n) => `${n} 晚`,
    total: "总计", taxes: "含税费",
    reserveNow: "预订", notCharged: "目前不会扣款",
    roomList: { count: (n) => `${n} 种房型`, swipe: "滑动查看其他房间。", guests: (n) => `${n} 位住客`,
                left: (n) => `剩余 ${n} 间`, full: "已满房", choose: "选择此房间", chosen: "已选择 ✓" },
  },
};

// components/HotelCard.jsx
export const hotelCardL = {
  en: {
    save: "Save",
    excellent: "Excellent", veryGood: "Very good", good: "Good",
    reviews: (n) => `${n} reviews`,
    stars: (n) => `${n}-star property`,
    perNight: " /night", taxes: "Includes taxes and fees",
    types: { hotel: 'Hotel', apartment: 'Apartment', house: 'House' },
    amenities: { wifi: 'Wi-Fi', parking: 'Parking', ac: 'Air conditioning', pool: 'Pool', kitchen: 'Kitchen', breakfast: 'Breakfast', gym: 'Gym', spa: 'Spa', beach: 'Beach access', restaurant: 'Restaurant', bar: 'Bar' },
    capacity: n => `Up to ${n} guests`, noPhoto: 'Photo not available',
    stayTotal: (n) => `total for ${n} night${n > 1 ? 's' : ''}`,
  },
  fr: {
    save: "Enregistrer",
    excellent: "Excellent", veryGood: "Très bien", good: "Bien",
    reviews: (n) => `${n} avis`,
    stars: (n) => `Établissement ${n} étoile${n > 1 ? 's' : ''}`,
    perNight: " /nuit", taxes: "Taxes et frais compris",
    types: { hotel: 'Hôtel', apartment: 'Appartement', house: 'Maison' },
    amenities: { wifi: 'Wi-Fi', parking: 'Parking', ac: 'Climatisation', pool: 'Piscine', kitchen: 'Cuisine', breakfast: 'Petit-déjeuner', gym: 'Salle de sport', spa: 'Spa', beach: 'Accès plage', restaurant: 'Restaurant', bar: 'Bar' },
    capacity: n => `Jusqu’à ${n} voyageurs`, noPhoto: 'Photo indisponible',
    stayTotal: (n) => `total pour ${n} nuit${n > 1 ? 's' : ''}`,
  },
  es: {
    save: "Guardar",
    excellent: "Excelente", veryGood: "Muy bien", good: "Bien",
    reviews: (n) => `${n} opiniones`,
    stars: (n) => `Alojamiento de ${n} estrella${n > 1 ? 's' : ''}`,
    perNight: " /noche", taxes: "Impuestos y tasas incluidos",
    types: { hotel: 'Hotel', apartment: 'Apartamento', house: 'Casa' },
    amenities: { wifi: 'Wi-Fi', parking: 'Estacionamiento', ac: 'Aire acondicionado', pool: 'Piscina', kitchen: 'Cocina', breakfast: 'Desayuno', gym: 'Gimnasio', spa: 'Spa', beach: 'Acceso a la playa', restaurant: 'Restaurante', bar: 'Bar' },
    capacity: n => `Hasta ${n} huéspedes`, noPhoto: 'Foto no disponible',
    stayTotal: (n) => `total por ${n} noche${n > 1 ? 's' : ''}`,
  },
  pt: {
    save: "Guardar",
    excellent: "Excelente", veryGood: "Muito bom", good: "Bom",
    reviews: (n) => `${n} avaliações`,
    stars: (n) => `Alojamento de ${n} estrela${n > 1 ? 's' : ''}`,
    perNight: " /noite", taxes: "Inclui impostos e taxas",
    types: { hotel: 'Hotel', apartment: 'Apartamento', house: 'Casa' },
    amenities: { wifi: 'Wi-Fi', parking: 'Estacionamento', ac: 'Ar condicionado', pool: 'Piscina', kitchen: 'Cozinha', breakfast: 'Pequeno-almoço', gym: 'Ginásio', spa: 'Spa', beach: 'Acesso à praia', restaurant: 'Restaurante', bar: 'Bar' },
    capacity: n => `Até ${n} hóspedes`, noPhoto: 'Foto indisponível',
    stayTotal: (n) => `total para ${n} noite${n > 1 ? 's' : ''}`,
  },
  ar: {
    save: "حفظ",
    excellent: "ممتاز", veryGood: "جيد جدًا", good: "جيد",
    reviews: (n) => `${n} تقييمًا`,
    stars: (n) => `مكان إقامة ${n} ${n > 1 ? 'نجوم' : 'نجمة'}`,
    perNight: " /ليلة", taxes: "شامل الضرائب والرسوم",
    types: { hotel: 'فندق', apartment: 'شقة', house: 'منزل' },
    amenities: { wifi: 'واي فاي', parking: 'موقف سيارات', ac: 'تكييف هواء', pool: 'مسبح', kitchen: 'مطبخ', breakfast: 'إفطار', gym: 'صالة رياضية', spa: 'سبا', beach: 'وصول إلى الشاطئ', restaurant: 'مطعم', bar: 'بار' },
    capacity: n => `حتى ${n} نزلاء`, noPhoto: 'الصورة غير متاحة',
    stayTotal: (n) => `الإجمالي لـ ${n} ${n > 1 ? 'ليالٍ' : 'ليلة'}`,
  },
  zh: {
    save: "收藏",
    excellent: "极佳", veryGood: "很好", good: "好",
    reviews: (n) => `${n} 条点评`,
    stars: (n) => `${n} 星级住宿`,
    perNight: " /晚", taxes: "含税费",
    types: { hotel: '酒店', apartment: '公寓', house: '独栋房屋' },
    amenities: { wifi: 'Wi-Fi', parking: '停车场', ac: '空调', pool: '泳池', kitchen: '厨房', breakfast: '早餐', gym: '健身房', spa: '水疗', beach: '海滩直达', restaurant: '餐厅', bar: '酒吧' },
    capacity: n => `最多 ${n} 位住客`, noPhoto: '暂无照片',
    stayTotal: (n) => `${n} 晚总价`,
  },
};

// pages/FlightHotel.jsx — the page's introduction, read with the other service
// introductions (i18n/servicePresentations.test.jsx). The form, the facts and
// the questions are flightHotelPageL in i18n/flighthotel.js, which only that
// page loads.
export const flightHotelL = {
  en: {
    eyebrow: "Flight + Hotel",
    // No number: nothing on this page computes a saving. There is no packages
    // endpoint and the form routes to a plain stays search. A figure nothing
    // calculates is not a saving, it is a claim.
    headline: "Your getaway takes shape", heroAccent: "takes shape",
    sub: "Find your stay, then your flight. Each is booked separately.",
    // What the search button finds: its visible label is the short "Search"
    // (the owner's choice, 2026-10-02); this says where it leads, as the
    // button's description and tooltip.
    submit: "Search stays",
  },
  fr: {
    eyebrow: "Vol + Hôtel",
    headline: "Votre escapade prend forme", heroAccent: "prend forme",
    sub: "Trouvez votre hébergement, puis votre vol. Réservez-les séparément.",
    submit: "Rechercher un hébergement",
  },
  es: {
    eyebrow: "Vuelo + Hotel",
    headline: "Una escapada a su medida", heroAccent: "a su medida",
    sub: "Encuentre alojamiento y después su vuelo. Se reservan por separado.",
    submit: "Buscar alojamiento",
  },
  pt: {
    eyebrow: "Voo + Hotel",
    headline: "Uma escapadinha à sua medida", heroAccent: "à sua medida",
    sub: "Encontre alojamento e depois o voo. Reserve cada serviço separadamente.",
    submit: "Pesquisar alojamento",
  },
  ar: {
    eyebrow: "طيران + فندق",
    headline: "رحلة على طريقتك", heroAccent: "على طريقتك",
    sub: "اختر إقامتك ثم رحلتك الجوية. احجز كل خدمة بشكل منفصل.",
    submit: "البحث عن إقامة",
  },
  zh: {
    eyebrow: "机票 + 酒店",
    headline: "您的旅行，由您安排", heroAccent: "由您安排",
    sub: "先选住宿，再找航班，各项服务分别预订。",
    submit: "搜索住宿",
  },
};

// pages/checkout/StayBooking.jsx: the website's one page after "Réserver" on a
// stay (owner, 2026-10-30): the room, the traveller's details, the card, one button.
export const stayBookingL = {
  en: {
    title: "Complete your booking", sub: "Your room, your details and your card, on one page.",
    change: "Change", arrival: "Check-in", departure: "Check-out",
    detailsHint: "Your confirmation and booking number are sent to this email.",
    accountNote: "Your account's details: the booking is made in this name.",
    haveAccount: "Have an account?", signIn: "Sign in",
    locked: "These details are saved with the booking.",
    priceTitle: "Your price summary", taxes: "Taxes & fees", included: "Included", total: "Total",
    chargedNote: "The card is charged in US dollars (USD); the total above is shown in your currency.",
    bookAndPay: (total) => `Book and pay ${total}`, bookShort: "Book and pay",
    unavailable: "This room can no longer be booked for these dates or this number of guests.",
    noDates: "Choose your dates on the property's page first.", backToStay: "Back to the property",
    loading: "Loading your booking…", cardLoading: "Opening the secure payment…",
    payError: "We couldn't start the payment. Try again.",
  },
  fr: {
    title: "Finalisez votre réservation", sub: "Votre chambre, vos coordonnées et votre carte, sur une seule page.",
    change: "Modifier", arrival: "Arrivée", departure: "Départ",
    detailsHint: "La confirmation et votre numéro de réservation sont envoyés à cet e-mail.",
    accountNote: "Les coordonnées de votre compte : la réservation est faite à ce nom.",
    haveAccount: "Vous avez un compte ?", signIn: "Se connecter",
    locked: "Ces coordonnées sont enregistrées avec la réservation.",
    priceTitle: "Récapitulatif du prix", taxes: "Taxes & frais", included: "Inclus", total: "Total",
    chargedNote: "La carte est débitée en dollars américains (USD) ; le total ci-dessus est affiché dans votre devise.",
    bookAndPay: (total) => `Réserver et payer ${total}`, bookShort: "Réserver et payer",
    unavailable: "Cette chambre ne peut plus être réservée pour ces dates ou ce nombre de voyageurs.",
    noDates: "Choisissez d'abord vos dates sur la page de l'hébergement.", backToStay: "Revenir à l'hébergement",
    loading: "Chargement de votre réservation…", cardLoading: "Ouverture du paiement sécurisé…",
    payError: "Impossible de démarrer le paiement. Réessayez.",
  },
  es: {
    title: "Finaliza tu reserva", sub: "Tu habitación, tus datos y tu tarjeta, en una sola página.",
    change: "Cambiar", arrival: "Llegada", departure: "Salida",
    detailsHint: "La confirmación y tu número de reserva se envían a este correo.",
    accountNote: "Los datos de tu cuenta: la reserva se hace a este nombre.",
    haveAccount: "¿Tienes una cuenta?", signIn: "Iniciar sesión",
    locked: "Estos datos se guardan con la reserva.",
    priceTitle: "Resumen del precio", taxes: "Impuestos y tasas", included: "Incluidos", total: "Total",
    chargedNote: "La tarjeta se carga en dólares estadounidenses (USD); el total de arriba se muestra en tu moneda.",
    bookAndPay: (total) => `Reservar y pagar ${total}`, bookShort: "Reservar y pagar",
    unavailable: "Esta habitación ya no se puede reservar para estas fechas o este número de viajeros.",
    noDates: "Elige primero tus fechas en la página del alojamiento.", backToStay: "Volver al alojamiento",
    loading: "Cargando tu reserva…", cardLoading: "Abriendo el pago seguro…",
    payError: "No pudimos iniciar el pago. Inténtalo de nuevo.",
  },
  pt: {
    title: "Conclua a sua reserva", sub: "O seu quarto, os seus dados e o seu cartão, numa só página.",
    change: "Alterar", arrival: "Chegada", departure: "Partida",
    detailsHint: "A confirmação e o número da reserva são enviados para este e-mail.",
    accountNote: "Os dados da sua conta: a reserva é feita neste nome.",
    haveAccount: "Tem uma conta?", signIn: "Iniciar sessão",
    locked: "Estes dados ficam guardados com a reserva.",
    priceTitle: "Resumo do preço", taxes: "Impostos e taxas", included: "Incluídos", total: "Total",
    chargedNote: "O cartão é debitado em dólares americanos (USD); o total acima é apresentado na sua moeda.",
    bookAndPay: (total) => `Reservar e pagar ${total}`, bookShort: "Reservar e pagar",
    unavailable: "Este quarto já não pode ser reservado para estas datas ou este número de viajantes.",
    noDates: "Escolha primeiro as datas na página do alojamento.", backToStay: "Voltar ao alojamento",
    loading: "A carregar a sua reserva…", cardLoading: "A abrir o pagamento seguro…",
    payError: "Não foi possível iniciar o pagamento. Tente novamente.",
  },
  ar: {
    title: "أكمل حجزك", sub: "غرفتك وبياناتك وبطاقتك في صفحة واحدة.",
    change: "تعديل", arrival: "الوصول", departure: "المغادرة",
    detailsHint: "يُرسل التأكيد ورقم الحجز إلى هذا البريد الإلكتروني.",
    accountNote: "بيانات حسابك: يتم الحجز بهذا الاسم.",
    haveAccount: "لديك حساب؟", signIn: "تسجيل الدخول",
    locked: "تُحفظ هذه البيانات مع الحجز.",
    priceTitle: "ملخص السعر", taxes: "الضرائب والرسوم", included: "مشمولة", total: "الإجمالي",
    chargedNote: "تُخصم المبالغ من البطاقة بالدولار الأمريكي (USD)؛ ويظهر الإجمالي أعلاه بعملتك.",
    bookAndPay: (total) => `احجز وادفع ${total}`, bookShort: "احجز وادفع",
    unavailable: "لم يعد بالإمكان حجز هذه الغرفة لهذه التواريخ أو لهذا العدد من المسافرين.",
    noDates: "اختر تواريخك أولاً في صفحة مكان الإقامة.", backToStay: "العودة إلى مكان الإقامة",
    loading: "جارٍ تحميل حجزك…", cardLoading: "جارٍ فتح الدفع الآمن…",
    payError: "تعذّر بدء الدفع. حاول مرة أخرى.",
  },
  zh: {
    title: "完成您的预订", sub: "您的房间、联系方式和银行卡，都在同一页。",
    change: "修改", arrival: "入住", departure: "退房",
    detailsHint: "确认信息和预订编号将发送到此邮箱。",
    accountNote: "您账户的信息：预订将以此姓名进行。",
    haveAccount: "已有账户？", signIn: "登录",
    locked: "这些信息已随预订保存。",
    priceTitle: "价格明细", taxes: "税费", included: "已包含", total: "总价",
    chargedNote: "银行卡以美元（USD）扣款；上方总价以您选择的币种显示。",
    bookAndPay: (total) => `预订并支付 ${total}`, bookShort: "预订并支付",
    unavailable: "该房间在这些日期或这一人数下已无法预订。",
    noDates: "请先在住宿页面选择日期。", backToStay: "返回住宿页面",
    loading: "正在加载您的预订…", cardLoading: "正在打开安全支付…",
    payError: "无法开始支付，请重试。",
  },
};

// Wolof: the presentation texts only, every other word French (i18n/wolof.js).
hotelsL.wo = withWolof(hotelsL.fr, WOLOF.hotels, "hotels");
flightHotelL.wo = withWolof(flightHotelL.fr, WOLOF.flightHotel, "flightHotel");
